/* --------------------------------------------------------
JavaScript for Hoodrich
version: 1.0
author: Kubix Media
email: development@kubixmedia.co.uk
website: https://kubixmedia.co.uk
---------------------------------------------------------- */
// import footer_accordion from './modules/accordion';
// const Footeraccordion = new footer_accordion();

import GenderTagForNewCustomers from "./modules/GenderTag";
import LoyaltyLionRewardsColour from "./modules/LoyaltyLionRewardsColour";
import SizeTabs from "./modules/SizeTabs";
import Accordion from "./modules/Accordions";
import CentimetersToInches from "./modules/CentimetersToInches";
import LoyaltyPoints from "./modules/LoyaltyPoints";
import ProductCardForm from "./modules/ProductCardForm";
import sizeGuideChart from "./modules/SizeGuideChart";
//import CheckForAutofill from "./modules/CheckForAutofill";

let tabby = require("tabbyjs");
window.onload = (event) => {
  new tabby("[data-tabs]");
  new LoyaltyLionRewardsColour();
};

new GenderTagForNewCustomers();
new SizeTabs();
new Accordion();
new CentimetersToInches();
new LoyaltyPoints;
new ProductCardForm;
new sizeGuideChart();
//new CheckForAutofill;